import React from "react";
import { Truck, Leaf, Headphones, CreditCard } from "lucide-react";

export default function Features() {
    const featuressection = [
        {
            icon: <Truck className="icon" />,
            title: "Free Delivery",
            subtitle: "From ₹1000",
        },
        {
            icon: <Leaf className="icon" />,
            title: "Quality Products",
            subtitle: "Trusted Brands",
        },
        {
            icon: <CreditCard className="icon" />,
            title: "Secure Payments",
            subtitle: "Multiple Options",
        },
        {
            icon: <Headphones className="icon" />,
            title: "Support 24×7",
            subtitle: "Anytime Help",
        },
    ];

    return (
        <>
            <style>
                {`
          .features-wrapper h1
        { 
             text-align: center;
            font-size: 2.75rem;
            margin-bottom: 30px;
            color: #28a745;
            font-weight: 700;
            text-transform:uppercase;
        }
          
        .features-wrapper {
            width: 100%;
            background: #f4faf8;
            padding: 40px 20px;
            display: flex;
            justify-content: center;
            flex-direction:column;
            align-items:center;
            gap:20px
          }

          .features-container {
            width: 100%;
            max-width: 1200px;
            background: #ffffff;
            padding: 40px;
            border-radius: 20px;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 30px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          }

          .feature-box {
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 12px;
          }

          .icon {
            width: 48px;
            height: 48px;
            color: #28a745;
          }

          .feature-title {
            font-size: 18px;
            font-weight: 600;
            color: #28a745;
            margin: 0;
          }

          .feature-sub {
            font-size: 14px;
            color: #666;
            margin: 0;
          }

          /* Responsive */
          @media (max-width: 1024px) {
            .features-container {
              grid-template-columns: repeat(2, 1fr);
            }
          }

          @media (max-width: 600px) {
            .features-container {
              padding: 30px 20px;
            }
          }
        `}
            </style>

            <div className="features-wrapper">
                <h1>Our Services</h1>
                <div className="features-container">
                    {featuressection.map((item, index) => (
                        <div key={index} className="feature-box">
                            {item.icon}
                            <h3 className="feature-title">{item.title}</h3>
                            <p className="feature-sub">{item.subtitle}</p>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
